<template>
  <CDropdown head-class="cursor-pointer" wrapper-class="" dir="ltr">
    <template #head="{ show }">
      <div
        class="transition-300 flex items-center justify-between gap-1 group p-1 rounded-md"
      >
        <div class="flex-y-center space-x-2 text-gray-700">
          <div class="w-6 rounded-sm overflow-hidden">
            <img
              :src="currentLanguage?.icon"
              alt="flags"
              class="w-full h-full object-cover"
            />
          </div>
          <span class="text-2xs leading-[123%] font-semibold" v-if="isDesktop">
            {{ currentLanguage?.label }}
          </span>
          <i
            class="icon-chevron-down transition-200 text-xs inline-block"
            v-if="isDesktop"
            :class="{ 'rotate-180': show }"
          ></i>
        </div>
      </div>
    </template>

    <ul class="p-2">
      <li
        v-for="(item, index) in languages"
        :key="index"
        class="transition-200 min-w-[118px] w-[150px] px-3 py-2 rounded text-2xs font-semibold text-dark-100 hover:bg-gray-300/[0.24] flex-y-center justify-start gap-4"
        @click="changeLocale(item.value)"
        :class="{ 'bg-gray-300': item.value === currentLanguage?.value }"
      >
        <div class="!w-9 rounded-sm overflow-hidden">
          <img
            :src="item?.icon"
            alt="flags"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="w-full flex-y-center justify-between gap-2">
          <span>{{ item.label }}</span>
          <i
            v-if="item.value === currentLanguage?.value"
            class="icon-tick-square text-green"
          ></i>
        </div>
      </li>
    </ul>
  </CDropdown>
</template>

<script setup lang="ts">
import { computed } from "vue";
import CDropdown from "@/components/Common/Dropdown/CDropdown.vue";
import { ELanguage, ILanguage } from "@/types/components/languageSwitcher";
import { useMobile } from "@/composables/useMobile";
import { useLocalizedNavigation } from "@/composables/useLocalizedNavigation";
import i18n from "@/plugins/i18n";
import { useI18n } from "vue-i18n";
import ApiService from "@/services/ApiService";

const { isDesktop } = useMobile("desktop");
const { locale } = useI18n();

const { switchLocale } = useLocalizedNavigation();

const languages: ILanguage[] = [
  {
    value: ELanguage.UZ,
    label: "O'zbekcha",
    icon: "/flags/uz.svg",
  },
  {
    value: ELanguage.EN,
    label: "English",
    icon: "/flags/en.svg",
  },
  {
    value: ELanguage.RU,
    label: "Русский",
    icon: "/flags/ru.svg",
  },
  {
    value: ELanguage.AR,
    label: "Arabic",
    icon: "/flags/ar.svg",
  },
];

const currentLanguage = computed(() => {
  const currentLocale = locale.value || "en";

  return languages.find((lang) => lang.value === currentLocale);
});

function changeLocale(_locale: ELanguage) {
  // Store the new locale
  window.localStorage.setItem("locale", _locale);

  // Update i18n locale
  i18n.global.locale.value = _locale as "en" | "ru" | "uz" | "ar";

  // Use our specialized composable for locale switching
  switchLocale(_locale);
  document.dir = _locale === "ar" ? "rtl" : "ltr";
  ApiService.setHeader();
}
</script>
